import { PaginatedResponse, PaginationParams } from '@console/utils';
import { apiClient } from './client';

export interface Notification {
  id: string;
  title: string;
  content: string;
  type: string;
  contract?: {
    id: string;
    number: string;
    consumedHours: number;
    contractedHours: number;
    endDate?: Date;
    company: {
      id: string;
      name: string;
    };
  };
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationFilters extends PaginationParams {}

export const notificationsApi = {
  getAll: async (params?: NotificationFilters): Promise<PaginatedResponse<Notification>> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());

    const queryString = searchParams.toString();
    const response = await apiClient.get(`/notifications${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  markAsRead: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.patch(`/notifications/${id}/read`);
    return response.data;
  },

  getUnreadCount: async (): Promise<{ count: number }> => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data;
  },

  markAllAsRead: async (): Promise<{ message: string }> => {
    const response = await apiClient.patch('/notifications/mark-all-read');
    return response.data;
  },
};
